<template>
  <v-card tile style="position: relative" :loading="$store.getters.GET_LOADING">
    <v-card-title style="position: absolute;z-index: 1;">
      <v-row class="d-flex align-center justify-space-between ma-0 pa-0">
        <v-col cols="6" class="ma-0">
          <v-select :label="visitInfo.label"
                    v-model="date"
                    item-value="value"
                    :placeholder="visitInfo.placeholder"
                    @change="getRegions"
                    :items="visits"></v-select>
        </v-col>
        <v-col cols="6" class="ma-0">
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text id="map"
                 class="pa-0"
                 :style="size"></v-card-text>
  </v-card>
</template>

<script>
/* eslint-disable camelcase */
import * as am4core from '@amcharts/amcharts4/core'
import * as am4maps from '@amcharts/amcharts4/maps'
import am4geodata_worldLow from '@amcharts/amcharts4-geodata/worldLow'
import am4themes_animated from '@amcharts/amcharts4/themes/animated'
import am4themes_frozen from '@amcharts/amcharts4/themes/frozen'

export default {
  name: 'InteractiveMapV3Component',
  props: {
    size: null
  },
  data () {
    return {
      markers: [],
      date: 7,
      targetSVG: 'M9,0C4.029,0,0,4.029,0,9s4.029,9,9,9s9-4.029,9-9S13.971,0,9,0z M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93 M12.5,9c0,1.933-1.567,3.5-3.5,3.5S5.5,10.933,5.5,9S7.067,5.5,9,5.5 S12.5,7.067,12.5,9z'
    }
  },
  mounted () {
    this.getRegions()
    this.$root.$on('build-stats', () => {
      this.getRegions()
    })
  },
  methods: {
    buildMap (markers) {
      am4core.options.autoDispose = true
      am4core.options.queue = true
      am4core.useTheme(am4themes_frozen)
      am4core.useTheme(am4themes_animated)
      const chart = am4core.create('map', am4maps.MapChart)
      const colorSet = new am4core.ColorSet()

      chart.geodata = am4geodata_worldLow
      chart.projection = new am4maps.projections.Mercator()
      chart.zoomControl = new am4maps.ZoomControl()
      chart.homeZoomLevel = 5
      chart.homeGeoPoint = {
        latitude: 53.895222,
        longitude: 27.540721
      }

      const homeButton = new am4core.Button()
      homeButton.events.on('hit', () => {
        this.$router.push({ name: 'dashboard.admin.map' }).catch(() => {
        })
      })

      homeButton.icon = new am4core.Sprite()
      homeButton.padding(7, 5, 7, 5)
      homeButton.width = 30
      homeButton.icon.path = 'M5,5H10V7H7V10H5V5M14,5H19V10H17V7H14V5M17,14H19V19H14V17H17V14M10,17V19H5V14H7V17H10Z'
      homeButton.marginTop = 2.5
      homeButton.parent = chart.zoomControl
      homeButton.insertAfter(chart.zoomControl.minusButton)

      const polygonSeries = chart.series.push(new am4maps.MapPolygonSeries())
      polygonSeries.exclude = ['AQ']
      polygonSeries.useGeodata = true
      polygonSeries.mapPolygons.template.nonScalingStroke = true

      const polygonTemplate = polygonSeries.mapPolygons.template
      polygonTemplate.tooltipText = '{name}'
      polygonTemplate.polygon.fillOpacity = 0.6
      polygonTemplate.fill = colorSet.next()

      const hs = polygonTemplate.states.create('hover')
      hs.properties.fill = colorSet.next()

      const imageSeries = chart.series.push(new am4maps.MapImageSeries())
      const imageTemplate = imageSeries.mapImages.template
      imageTemplate.tooltipHTML = '<span>{title}, {country}</span>'
      imageTemplate.nonScaling = true

      const circle = imageSeries.mapImages.template.createChild(am4core.Circle)
      circle.radius = 6
      circle.propertyFields.fill = 'color'

      const circle2 = imageSeries.mapImages.template.createChild(am4core.Circle)
      circle2.radius = 6
      circle2.propertyFields.fill = 'color'

      imageTemplate.propertyFields.latitude = 'latitude'
      imageTemplate.propertyFields.longitude = 'longitude'

      imageSeries.data.push({
        title: 'Minsk',
        latitude: 53.895222,
        longitude: 27.540721,
        scale: 0.5,
        color: colorSet.next(),
        country: 'Belarus'
      })

      markers.forEach(marker => {
        imageSeries.data.push({
          title: marker.city,
          latitude: parseFloat(marker.latitude),
          longitude: parseFloat(marker.longitude),
          scale: 0.5,
          color: colorSet.next(),
          country: marker.country
        })
      })

      const lineSeries = chart.series.push(new am4maps.MapLineSeries())
      lineSeries.dataFields.multiGeoLine = 'multiGeoLine'

      const lineTemplate = lineSeries.mapLines.template
      lineTemplate.nonScalingStroke = true
      lineTemplate.arrow.nonScaling = true
      lineTemplate.arrow.width = 4
      lineTemplate.arrow.height = 6
      lineTemplate.stroke = colorSet.baseColor
      lineTemplate.fill = colorSet.next()
      lineTemplate.line.strokeOpacity = 0.4

      markers.forEach(marker => {
        lineSeries.data.push({
          multiGeoLine: [
            [
              {
                latitude: parseFloat(marker.latitude),
                longitude: parseFloat(marker.longitude)
              },
              {
                latitude: 53.895222,
                longitude: 27.540721
              }
            ]
          ]
        })
      })
    },
    async getRegions () {
      await this.$http.get(`api/v2/auth/regions/map/${this.date}`)
        .then(response => {
          this.markers = []
          response.data.regions.forEach(item => {
            const region = {
              city: item.city,
              longitude: parseFloat(item.longitude),
              latitude: parseFloat(item.latitude),
              country: item.country_name
            }
            this.markers.push(region)
          })
          this.buildMap(this.markers)
        })
    }
  },
  computed: {
    visits () {
      return this.$t('admin.dashboard.visits')
    },
    visitInfo () {
      return this.$t('admin.dashboard.visit')
    },
    websites () {
      return this.$t('admin.dashboard.websites')
    }
  }
}
</script>

<style scoped>

</style>
